const LEXNET_ERROR_KEYS: Record<string, string> = {
  '20001006': 'general.lexnet_error_20001006',
  '20005024': 'general.lexnet_error_20005024'
}

export function getLexnetErrorMessage(response: any, t: (key: string) => string): string {
  const key = LEXNET_ERROR_KEYS[String(response?.lexnetCode)]
  return key ? t(key) : response?.message
}
